import React from 'react';
import { Col, Input, Select, Tooltip } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import { useZoneTimePricingTaxiOverviewLinkStateActions } from './useZoneTimePricingTaxiOverviewLinkStateActions';
import { useOverviewLinkState } from '../linkstate/pricingTaxiOverview.linkstate';
import { useGetAllCityQuery } from '../../../GraphQL/hooks/useGetAllCityQuery';

export const TaxiZoneTimePricingFilter = () => {
    const { data: cities } = useGetAllCityQuery();
    const [{ search, selectedCities }] = useOverviewLinkState();
    const { patch: patchState } = useZoneTimePricingTaxiOverviewLinkStateActions();
    return (
        <>
            <Col md={{ span: 5 }}>
                <Input
                    value={search}
                    style={{ width: '100%' }}
                    placeholder={'Search by serviceName, Zone Base Percentage'}
                    onChange={(e) => patchState({ search: e.target.value })}
                    addonBefore={<SearchOutlined />}
                />
            </Col>
            <Col md={{ span: 3 }}>
                <Tooltip title={`Filter by City: ${(selectedCities ?? []).map((city) => `#${city}`).join(' ')}`}>
                    <Select
                        placeholder="Cities"
                        mode="multiple"
                        value={selectedCities ?? []}
                        style={{ width: '100%', height: 32 }}
                        maxTagCount={1}
                        maxTagTextLength={10}
                        onChange={(e) => patchState({ selectedCities: e })}
                    >
                        {(cities ?? []).map((city) => (
                            <Select.Option key={city._id} value={city.cityName}>
                                {city.cityName}
                            </Select.Option>
                        ))}
                    </Select>
                </Tooltip>
            </Col>
        </>
    );
};
